function GetLabel({ isRequired, label }) {
  return label + isRequired;
}

export default GetLabel;
